module.exports = __webpack_public_path__ + "static/media/emoji.2bb9374b.svg";